import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { use_store } from "../store";
import {
  faAt,
  faEye,
  faUserHatTieMagnifyingGlass,
} from "@fortawesome/pro-regular-svg-icons";

export const HowLuluWorks = () => {
  const { t } = use_store();
  return (
    <div className="flex flex-col gap-[24px] w-full">
      <p className="stitle w-full">{t("How Lulu Loyal Works")}</p>
      <div className="flex flex-col gap-[8px]">
        <FontAwesomeIcon
          icon={faAt}
          className="text-brand-2 mb-[8px] text-[20px]"
        ></FontAwesomeIcon>
        <p className="bigt">{t("Step 1 - Enter a Username")}</p>
        <p className="vsmallt">{t("Enter a username to start the search.")}</p>
      </div>
      <div className="flex flex-col gap-[8px]">
        <FontAwesomeIcon
          icon={faUserHatTieMagnifyingGlass}
          className="text-brand-2 mb-[8px] text-[20px]"
        ></FontAwesomeIcon>
        <p className="bigt">{t("Step 2 - Anonymous Search")}</p>
        <p className="vsmallt">{t("Do an untraceable, anonymous search.")}</p>
      </div>
      <div className="flex flex-col gap-[8px]">
        <FontAwesomeIcon
          icon={faEye}
          className="text-brand-2 mb-[8px] text-[20px]"
        ></FontAwesomeIcon>
        <p className="bigt">{t("Step 3 - Best Results")}</p>
        <p className="vsmallt">
          {t("Receive the best results, learn the truth.")}
        </p>
      </div>
    </div>
  );
};
